export { default } from "./MobileWeb";
